
import { TvProgramByProgDays } from '@rtl/api'
import { Options, Prop, Vue } from 'vue-property-decorator'

import { TvProgramItem } from '@rtl/api'
import AgeLimit from '../AgeLimit.vue'
import Modal from '../Modal.vue'

@Options({
  name: 'TvProgramModal',
  components: {
    AgeLimit,
    Modal
  }
})
export default class TvProgramModal extends Vue {
  @Prop({ type: Object, required: true })
  readonly programInfo!: TvProgramItem
}
